<template>
  <div class="common_content">
    <div class="news_detail">
      <el-card class="box-card">
        <el-row :gutter="24">
          <el-col :xs="24" :sm="24" :md="24" v-if="newsContents">
            <div class="news_detail_top">
              <h3>{{newsContents.news_subject}}</h3>
              <p class="date">创建时间:{{newsContents.createdate|dateformat('YYYY-MM-DD HH:mm')}}</p>
              <span @click="goBack">返回</span>
            </div>
            <div ref="detail" class="news_detail_bottom" v-html="newsContents.news_content"></div>
          </el-col>
        </el-row>
      </el-card>
    </div>
  </div>
</template>

<script>
import { GetNewsDetailsList } from "@/api/admin/common.js";
export default {
  data() {
    return {
      newsId: {},
      newsContents: {},
      url: "",
      imgPath: window.apiObj.apiUrl,
    };
  },
  created() {
    this.path();
    this.getDetail();
  },
  // watch: {
  //     '$route' (to, from) { //监听路由是否变化
  //         if(to.query.id != from.query.id){
  //             this.getDetail();//重新加载数据
  //         }
  //     }
  // },
  methods: {
    path() {
      var pathList = [
        { title: "您当前的位置" },
        { title: "首页", path: "/index" },
        { path: "/news", title: "新闻动态" },
        {
          title: "新闻动态详情"
        }
      ];
      setTimeout(() => {
        this.$store.commit("SET_ROUTELIST", pathList);
      });
    },
    getDetail() {
      this.newsId.id = this.$route.query.id;
      GetNewsDetailsList(Object.assign(this.newsId)).then(data => {
        var list = data.data.result;
        if (list) {
          this.newsContents = list.items[0];

          if (list.items[0].news_content) {
            this.newsContents.news_content = list.items[0].news_content.replace(
              new RegExp("/wwwroot", "gm"),
              this.imgPath
            );
          }
        }
      });
    },
    //返回
    goBack() {
      this.$router.go(-1);
    }
    // change(content){
    //   var reg ="/wwwroot";
    //   content = content.replace(reg,"www");
    //   return content
    // }
  }
};
</script>
<style lang="less" scoped>
.news_detail {
  .news_detail_top {
    padding-top: 15px;
    width: 85%;
    margin: auto;
    position: relative;
    h3 {
      text-align: center;
      font-size: 20px;
      font-weight: normal;
      line-height: 26px;
      padding: 0px 20px;
    }
    .date {
      text-align: center;
      font-size: 14px;
      color: #8a8a8a;
      margin: 20px 0 25px 0;
      border-bottom: 1px solid #cdcccc;
      padding-bottom: 15px;
    }
    span {
      cursor: pointer;
      position: absolute;
      color: #f56c6c;
      top: -4%;
      right: 0;
    }
  }
  .news_detail_bottom {
    width: 85%;
    margin: auto;
  }
}
@media screen and (max-width: 768px) {
  .news_detail {
    .box-card {
      .news_detail_top {
        width: 95%;
        h3 {
          font-size: 17px;
        }
        span {
          top: -5px;
          right: -12px;
          font-size: 14px;
        }
      }
      .news_detail_bottom {
        width: 95%;
      }
    }
  }
}
</style>
<style lang="less">
.news_detail {
  p {
    line-height: 28px;
  }
  img {
    width: 100%;
  }
}
</style>
